import {Breadcrumbs as MUIBreadcrumbs, Typography} from '@mui/material';
import Link from 'next/link';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronsRight} from '@fortawesome/pro-duotone-svg-icons';
import {stripHTMLTags} from "@/src/utils/strip-html-tags";

export default function Breadcrumbs({breadcrumbs, journal}: { breadcrumbs: any[], journal: any }) {
    return (
        <MUIBreadcrumbs
            separator={<FontAwesomeIcon icon={faChevronsRight} color={'common.black'} size={"sm"}/>}
            aria-label="breadcrumb"
            sx={{
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'left',
                paddingY: 1,
                fontSize: '.8rem',
                fontWeight: 900,
                ml: 2
            }}>
            <Link
                href="/"
                style={{
                    textDecoration: 'none',
                    color: '#02535b',
                    textTransform: 'capitalize',
                }}>
                <>
                {journal.is_main_site && journal.title || 'Home'}
                </>
            </Link>
            {breadcrumbs.map((value, index) => {
                const href = value.link;
                const isLast = index === breadcrumbs.length - 1;

                return !href || isLast ? (
                    <Typography key={href} sx={{
                        textTransform: 'capitalize',
                        color: isLast ? '#02535b' : '#6c757d',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '300px',
                        fontSize: '.8rem',
                        fontWeight: 900,
                    }}>
                        {
                            stripHTMLTags(value.name)
                        }
                    </Typography>
                ) : (
                    <Link
                        href={href}
                        key={href}
                        style={{
                            textDecoration: 'none',
                            color: '#02535b',
                            textTransform: 'capitalize',
                            fontWeight: 900,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '300px',
                        }}>
                        {
                            stripHTMLTags(value.name)
                        }
                    </Link>
                );
            })}
        </MUIBreadcrumbs>
    );
}
